<template>
    <div class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col w-full pb-4 sm:pb-8 mt-4 sm:mt-8">
                <div class="mb-4">
                    <bread-crumb :items="breadCrumbItems"></bread-crumb>
                </div>

                <section class="h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <h2 class="text-xl font-semibold text-gray-800 mb-6 flex items-center">
                        <font-awesome-icon :icon="['fas', 'university']" class="text-blue-500 mr-2" />
                        Campus Overview
                    </h2>

                    <div v-if="categories.length" class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        <router-link
                            v-for="category in categories"
                            :key="category.key"
                            :to="categoryPath(category.key)"
                            class="border rounded-xl p-6 flex items-center justify-center hover:shadow-md cursor-pointer transition"
                            :class="[category.bgClass, category.borderClass]"
                        >
                            <font-awesome-icon
                                :icon="category.icon"
                                class="text-2xl mr-3"
                                :class="category.iconClass"
                            />
                            <span class="text-lg font-medium text-gray-700">{{ category.title }}</span>
                        </router-link>
                    </div>

                    <div v-else class="text-center text-gray-500 py-8">
                        No categories available for this campus.
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from "../../components/shared/BreadCrumb.vue";
import { getCampusConfig, isValidCampus } from "./config";

export default {
    name: "adpoly-campus-overview",
    components: {
        BreadCrumb,
    },
    props: ["campus"],
    created() {
        this.validateCampus();
    },
    watch: {
        campus: function () {
            this.validateCampus();
        },
    },
    computed: {
        campusConfig() {
            return getCampusConfig(this.campus);
        },
        campusTitle() {
            return this.campusConfig ? this.campusConfig.title : "";
        },
        categories() {
            return this.campusConfig && this.campusConfig.categories
                ? this.campusConfig.categories
                : [];
        },
        breadCrumbItems() {
            return [
                { label: "Dashboard", path: "/dashboard" },
                { label: "ADPOLY", path: "/adpoly" },
                {
                    label: this.campusTitle || "Campus",
                    path: this.campusConfig ? "/adpoly/" + this.campusConfig.key : "/adpoly",
                },
                { label: "Campus" },
            ];
        },
    },
    methods: {
        validateCampus() {
            if (!isValidCampus(this.campus)) {
                this.$router.push({ path: "/notFound" });
            }
        },
        categoryPath(categoryKey) {
            if (!this.campusConfig) return "/adpoly";
            return "/adpoly/" + this.campusConfig.key + "/campus/" + categoryKey;
        },
    },
};
</script>

<style lang="scss" scoped></style>
